<template>
  <div>
    <ValidationObserver slim v-slot="{ handleSubmit, invalid }" ref="observer">
      <form @submit.prevent="handleSubmit(update)">
        <div class="flex flex-col">
          <div class="w-64">
            <ValidationProvider name="target" vid="target" v-slot="{ errors, failed }" slim>
              <BaseFormGroup>
                <BaseFormLabel> Target </BaseFormLabel>
                <BaseFormSelect
                  v-model="data.target"
                  :options="targetOptions"
                  :disabled="submitting"
                  :invalid="failed"
                />
                <BaseFormInlineMessage v-if="failed" danger>
                  {{ errors[0] }}
                </BaseFormInlineMessage>
              </BaseFormGroup>
            </ValidationProvider>
            <!-- <label
              for="target"
              class="inline-block font-medium text-sm mb-2"
            >Target</label>
            <select
              id="target"
              class="form-select block"
              v-model="data.target"
            >
              <option
                v-for="(option, idx) in targetOptions"
                :value="option.value"
                :key="`${_uid}_${idx}`"
              >
                {{ option.label }}
              </option>
            </select> -->
          </div>
          <!-- Target -->

          <div class="w-full flex mt-4">
            <div class="w-1/2">
              <label for="budget" class="inline-block font-medium text-sm mb-2"
                >Budget Forecast</label
              >
              <div class="flex">
                <ValidationProvider name="budget" vid="budget" v-slot="{ errors, failed }" slim>
                  <BaseFormGroup class="w-full">
                    <BaseFormInput
                      type="number"
                      v-model.number="data.budget"
                      min="0"
                      :disabled="submitting"
                      :invalid="failed"
                    />
                    <BaseFormInlineMessage v-if="failed" danger>
                      {{ errors[0] }}
                    </BaseFormInlineMessage>
                  </BaseFormGroup>
                </ValidationProvider>
                <!-- <input
                  id="budget"
                  type="number"
                  name="budget"
                  min="0"
                  v-model.number="data.budget"
                  :disabled="submitting"
                  class="form-input"
                > -->
                <ValidationProvider
                  name="budget per result"
                  vid="isBudgetPerResult"
                  v-slot="{ errors, failed }"
                  tag="div"
                >
                  <label class="inline-flex ml-8 items-center">
                    <input
                      type="checkbox"
                      name="isBudgetPerResult"
                      v-model="data.isBudgetPerResult"
                      :disabled="submitting"
                      class="form-checkbox"
                    />
                    <span class="ml-2 select-none font-medium text-sm whitespace-nowrap">
                      Per Result</span
                    >
                  </label>
                  <BaseFormInlineMessage v-if="failed" danger>
                    {{ errors[0] }}
                  </BaseFormInlineMessage>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <!-- Budget -->

          <div class="w-full flex mt-4">
            <div class="w-32">
              <label class="inline-block font-medium text-sm mb-2">Daily Budget</label>
              <div class="flex">
                <ValidationProvider
                  name="daily budget"
                  vid="dailyBudget"
                  v-slot="{ errors, failed }"
                  slim
                >
                  <BaseFormGroup class="w-full">
                    <BaseFormInput
                      type="number"
                      v-model.number="data.dailyBudget"
                      min="0"
                      :disabled="submitting"
                      :invalid="failed"
                    />
                    <BaseFormInlineMessage v-if="failed" danger>
                      {{ errors[0] }}
                    </BaseFormInlineMessage>
                  </BaseFormGroup>
                </ValidationProvider>
                <!-- <input
                  id="daily_budget"
                  type="number"
                  name="dailyBudget"
                  min="0"
                  v-model.number="data.dailyBudget"
                  :disabled="submitting"
                  class="form-input"
                > -->
              </div>
            </div>
          </div>
          <!-- Daily Budget -->

          <div class="w-48 mt-4">
            <ValidationProvider name="result" vid="result" v-slot="{ errors, failed }" slim>
              <BaseFormGroup class="w-full">
                <BaseFormLabel> Result </BaseFormLabel>
                <BaseFormInput
                  type="number"
                  v-model.number="data.result"
                  min="0"
                  :disabled="submitting"
                  :invalid="failed"
                />
                <BaseFormInlineMessage v-if="failed" danger>
                  {{ errors[0] }}
                </BaseFormInlineMessage>
              </BaseFormGroup>
            </ValidationProvider>
            <!-- <label
              for="result"
              class="inline-block font-medium text-sm mb-2"
            >Result</label>
            <input
              id="result"
              type="number"
              name="result"
              min="0"
              v-model.number="data.result"
              :disabled="submitting"
              class="form-input"
            > -->
          </div>
          <!-- Result -->

          <div class="mt-8 text-sm">
            <ul>
              <li>
                Charge per Result:
                <template v-if="budgetPerResult"> {{ formattedBudgetPerResult }} &euro; </template>
              </li>
              <li>
                Total Budget:
                <template v-if="totalBudget"> {{ formattedTotalBudget }} &euro; </template>
              </li>
            </ul>
          </div>

          <div class="mt-8">
            <BaseButton primary :disabled="submitting || invalid">
              <span v-if="!submitting">Update</span>
              <Loader v-else small inverse />
            </BaseButton>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { HTTP_UNPROCESSABLE_ENTITY } from '@/api/http-response-codes';
import veeValidateErrorsMixin from '@/mixins/veeValidateErrorsMixin';

const defaultData = {
  target: null,
  result: null,
  budget: null,
  dailyBudget: null,
  isBudgetPerResult: false,
};

export default {
  name: 'TabTargeting',
  mixins: [veeValidateErrorsMixin],
  props: {
    campaign: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    data: { ...defaultData },
    targetOptions: [
      { value: 'leads', label: 'Leads' },
      { value: 'views', label: 'Views' },
      { value: 'likes', label: 'Likes' },
    ],
    submitting: false,
  }),
  computed: {
    budgetPerResult() {
      if (!this.data.budget) return null;
      if (!this.data.result) return null;
      if (this.data.isBudgetPerResult) return this.data.budget;
      return this.data.budget / this.data.result;
    },
    totalBudget() {
      if (!this.budgetPerResult) return null;
      return this.budgetPerResult * this.data.result;
    },
    formattedBudgetPerResult() {
      if (!this.budgetPerResult) return this.budgetPerResult;
      return this.budgetPerResult.toFixed(2);
    },
    formattedTotalBudget() {
      if (!this.totalBudget) return this.totalBudget;
      return this.totalBudget.toFixed(2);
    },
  },
  created() {
    Object.keys(defaultData).forEach((prop) => {
      if (this.campaign[prop] !== undefined) {
        this.data[prop] = this.campaign[prop];
      }
    });
  },
  methods: {
    ...mapActions('ui/campaigns', ['updateCampaignPricing']),
    async update() {
      const submitWithErrorHandling = this.handleFormErrors(this.updateCampaignPricing);

      this.submitting = true;

      await submitWithErrorHandling({
        campaignId: this.campaign.id,
        pricingData: this.data,
      });

      this.submitting = false;
    },
    handleFormErrors(fn) {
      return (...params) =>
        fn(...params)
          .then(() => {
            if (this.closeOnSuccess) {
              this.$refs.modal.doClose();
            }
          })
          .catch(({ status, data } = {}) => {
            // do sth with the error!
            if (status && status === HTTP_UNPROCESSABLE_ENTITY) {
              this.observer = this.$refs.observer;
              this.addServerErrors(data.errors);
            }
          });
    },
  },
};
</script>
